import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function Card({
  children,
  className = '',
  delay = 0
}: CardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay
  }} className={`glass-card rounded-xl p-6 md:p-8 ${className}`} data-id="element-235">
      {children}
    </motion.div>;
}